import {Component, OnInit, ViewChild} from '@angular/core';
import {ApprovalRequestEntity, QARService, SORUserEntity, SystemEntity} from '../services/qar.service';
import {ActivatedRoute} from '@angular/router';
import {AppUser} from '../framework/AppUser';
import {FileInfo, UploadInterface} from '../framework/ui/uploader';
import {UIInputAutocompleterComponent} from '../framework/ui/input-autocompleter';


@Component({
	selector: 'app-page-approval-request',
	templateUrl: './approval-request.html',
	providers: [QARService]
})
export class ApprovalRequestPageComponent implements OnInit, UploadInterface {
	@ViewChild('autocompleter', {static: true}) autocompleter: UIInputAutocompleterComponent;
	public self = this;

	constructor(public apiQAR: QARService, public route: ActivatedRoute, public user: AppUser) {

	}


	ngOnInit() {
		this.route.paramMap.subscribe(bag => {
			console.log('bag', bag);
			this.ar_loadById(bag['params']['id']);
		});
	}

	new_addUser() {
		const user = this.autocompleter.formControl.value;
		this.autocompleter.formControl.setValue('');
		this.autocompleter.formControl.reset();
	}

	public helper_idFunctionSORUserName(ar: ApprovalRequestEntity) {
		return ar.SORUser.FirstName + ' ' + ar.SORUser.LastName;
	}

	public helper_idFunctionSORUserEmail(ar: ApprovalRequestEntity) {
		return ar.SORUser.Email;
	}

	public helper_autocomplete_displaySelectedUsername(option: SORUserEntity) {
		if (!option) {
			return '';
		}
		return option.FirstName + ' ' + option.LastName + ' (' + option.Login + ')';
	}

	public helper_autocomplete_search(search) {
		return this.apiQAR.searchSORUser(search);
	}

	public ar = {
		decision: null,
		buttons: [
			{
				status: 'approved',
				label: 'Approve',
				cssClass: 'success white-important'
			}, {
				status: 'rejected',
				label: 'Reject',
				cssClass: 'danger white-important'
			}],
		loading: true,
		saving: false,
		canApprove: false,
		canCounterSign: false,
		canCancelReassign: false,
		uploaded: [],
		file64: '',
		data: new ApprovalRequestEntity()
	};


	public ar_counterSign() {
		if (!this.ar.canCounterSign) {
			return;
		}
		this.apiQAR.counterSignApprovalRequest(this.ar.data).then(r => {
			this.ngOnInit();
		});
	}

	public ar_cancel() {
		if (!this.ar.canCancelReassign) {
			return;
		}
		if (confirm('Are you sure you want to cancel this approval request?')) {
			this.apiQAR.cancelApprovalRequest(this.ar.data.Id).then(r => {
				this.ngOnInit();
			});
		}
	}

	public ar_reInstate() {
		if (!this.ar.canCancelReassign) {
			return;
		}
		if (confirm('Are you sure you want to reinstate this approval request?')) {
			this.apiQAR.reinstateApprovalRequest(this.ar.data.Id).then(r => {
				this.ngOnInit();
			});
		}
	}

	public reAssign = {
		modalHidden: true,
		title: '',
		userId: null,
		reassignApprovalRequest: false
	};

	public ar_reAssign() {
		this.reAssign.modalHidden = false;
		this.reAssign.title = 'Re-assign approval request';
	}

	public reassignApprovalRequest() {
		const selectedValue = this.autocompleter.formControl.value; // this is a full SORUserEntity
		this.reAssign.userId = selectedValue.Id;

		if (!this.reAssign.userId) {
			alert('Missing user');
			return;
		} else {
			this.apiQAR.reassignApprovalRequest(this.ar.data.Id, this.reAssign.userId).then(r => {
				this.ngOnInit();
				this.reAssign.modalHidden = true;
				alert('Approval request re-assigned');
				document.location.reload();
			}, e => {
				alert('error!');
			});
		}
	}

	public ar_buttons(data) {
		const ret = [];
		for (const r of data) {
			ret.push({
				status: r,
				label: this.ar_button_label(r),
				cssClass: this.ar_button_cssClass(r)
			});
		}
		return ret;
	}

	ar_button_cssClass(status) {
		switch (status) {
			case 'approved':
			case 'modified':
			case 'acknowledged':
				return 'success white-important';
			case 'cancelled':
			case 'rejected':
				return 'danger white-important';
			case 'pending':
				return 'useless bg-greyDark-important white-important';
			default:
				return 'default-important';
		}
	}

	ar_button_label(status) {
		switch (status) {
			case 'rejected':
				return 'Reject';
			case 'acknowledged':
				return 'Acknowledge';
			case 'approved':
				return 'Approve (no changes)';
			case 'modified':
				return 'Approve & Request Changes';
		}
		return status;
	}

	public ar_loadById(id: number) {
		this.ar.loading = true;
		this.apiQAR.retrieveApprovalRequest(id).then(r => {
			this.ar.loading = false;
			this.ar.data = r['Request'];
			this.ar.file64 = r['File64'];
			if (r['Request']['PossibleStatuses']) {
				this.ar.buttons = this.ar_buttons(r['Request']['PossibleStatuses'].split('|'));
			}
			this.ar.decision = r['Request']['StatusId'];
			console.log(this.ar.data.SORUser.Login.toLowerCase(), this.user.getLogin().toLowerCase());
			this.ar.canApprove = this.ar.data.SORUser.Login.toLowerCase() === this.user.getLogin().toLowerCase();
			this.ar.canCounterSign = this.user.hasGroup('SUPER_APPROVERS');
			this.ar.canCancelReassign = this.user.hasGroup('ADMINS');
			this.ar.uploaded = this.attachmentsAsArray(this.ar.data.Attachments);
		}, e => {
			alert('Sorry, something went wrong');
			this.ar.loading = false;
		});
	}

	public ar_downloadFile() {
		const source = `data:application/pdf;base64,` + this.ar.file64;
		const link = document.createElement('a');
		link.href = source;
		link.download = this.ar.data.Filepath;
		link.click();
	}

	public ar_onDecisionChange(button) {
		if (!this.ar.canApprove) {
			return;
		}
		this.ar.saving = true;
		console.log('ar_onDecisionChange', button);
		this.apiQAR.decisionOnApprovalRequest(this.ar.data.Id, button.status, this.ar.data.Comments).then(r => {
			this.ar.data = r;
			this.ar.saving = false;
			this.ar.decision = button.status;
			this.alert(('You have selected "' + (button.label)) + '"', 'Your decision was saved');
		}, e => {

			if (e.status === 409) {
				alert('Sorry, you are no longer allowed to update this request as it has been counter signed');
			} else {
				this.alert('Sorry, something went wrong, please try again', 'Error');
			}

			this.ar.saving = false;
		});
	}

	public alert(text, title = 'Warning') {
		this.modalAlert.display = true;
		this.modalAlert.title = title;
		this.modalAlert.text = text;
		this.modalAlert.cb = (yesorno) => {
			this.modalAlert.display = false;
		};
	}

	public modalAlert = {
		display: false,
		title: '',
		text: '',
		cb: (yesorno) => {
		}
	};


	uploadAcceptsFile(file: File): boolean {
		return true;
	}

	uploadDone(files: FileInfo[]) {
		const asString = [];
		for (const f of files) {
			console.log({f});
			asString.push(f.base64);
			asString.push(f.name);
		}

		this.apiQAR.uploadOnApprovalRequest(this.ar.data.Id, asString.join('||||||')).then(r => {

		}, (e) => {
			if (e['status'] === 409) {
				alert('Sorry, you are no longer allowed to update this request as it has been counter signed');
				return false;
			}else{
				alert('Sorry, error');
			}
			console.log('e', e, e.status);
		});
	}

	public attachmentsAsArray(Attachments): AttachmentsAsArrayItem[] {
		console.log('attachmentsAsArray', Attachments);
		if (!Attachments) {

			return [];
		}
		const ret = [];
		const atts = Attachments.split('||||||');
		for (let i = 0; i < atts.length; i += 2) {
			ret.push({base64: atts[i], name: atts[i + 1]});
		}
		return ret;
	}

}

export class AttachmentsAsArrayItem {
	public name;
	public base64;
}
